module.exports = __webpack_public_path__ + "static/img/icon_szh_cgal_gk_swkfh@2x.087b7838.png";